import React from 'react';
import {
  withStyles,
  Grid,
  Typography,
  Button,
  IconButton,
  List,
  ListItem,
  Card,
  CardContent,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Tooltip,
} from '@material-ui/core';
import { observer, inject } from 'mobx-react';
import '../../maps/styles/badge.css';
import { withTranslation } from 'react-i18next';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet';
import './style.css';
import { defaultMarker, redMarker } from './MarkerIcon';
import { getTimeFormatted } from '../../../utils/timeFormatted';

import { KeyboardArrowRight, AccountCircle, Home, Router, ExpandMore, LocationOn } from '@material-ui/icons';

class Maps extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      center: {
        lat: 13.7563,
        lng: 100.5018,
      },
      zoom: 13,
      openPlan: false,
      position: {},
      data: {
        patients: [],
        userAddress: '',
        tel: '',
        amountOfHome: 0,
      },
      latitude: '',
      longitude: '',
      id: '',
      openSidebar: true,
      routerSerial: '',
      routerIcon: false,
      tab: 0,
      deviceSerial: '',
    };
  }

  handleClick = async (event) => {
    let mapGroup = [];
    const { markerData } = this.props.patient.toJS();
    const information = (markerData || []).filter(
      (val) => val.position.lat === event.latlng.lat && val.position.lng === event.latlng.lng,
    );
    for (const data of information) {
      if (data.subgroup.mapId) {
        const maps = await this.props.maps._getMapById(data.subgroup.mapId);
        mapGroup.push(maps);
        await this.props.maps.setMaps(mapGroup);
        this.props.maps.setMapById(data.subgroup.mapId);
        this.setState({
          openPlan: true,
          position: {},
        });

        const routerMap = await this.props.router.getRouterMap(data.subgroup.mapId);
        const alertedRouters = routerMap.filter(
          (val) => !val.routerConnection || val.routerConnection.status === 'DISCONNECTED',
        );
        if (alertedRouters.length > 0) {
          const formatedData = alertedRouters.map((val) => {
            return val.serial;
          });
          this.props.dashboard.setAlertRouter(formatedData, 'alertDb');
        }
      }
    }
  };

  handleClose = async () => {
    this.setState({ openPlan: false });
    await this.props.maps.clearMap();
  };

  onMouseOver = (event) => {
    event.target.openPopup();
    this.props.patient.setUserInformation(event.latlng);
    this.setState({
      position: event.latlng,
    });
    let patients = [];
    const { markerData } = this.props.patient.toJS();
    const information = (markerData || []).filter(
      (val) => val.position.lat === event.latlng.lat && val.position.lng === event.latlng.lng,
    );
    information.forEach((data) => {
      if (data.patients) {
        patients = [...patients, ...(data.patients || []).map((val) => val)];
      }
      this.setState({
        data: {
          patients: patients,
          userAddress: information.length > 1 ? '' : data.userAddress,
          tel: information.length > 1 ? '' : data.userAddress.tel || '-',
          amountOfHome: information.length,
        },
      });
    });
  };

  onMouseOut = (event) => {
    event.target.closePopup();
    this.setState({
      position: {},
    });
  };

  handleToggle() {
    this.setState((state) => ({ openSidebar: !state.openSidebar }));
  }

  onMouseOverUserInfo = (value, event) => {
    this.setState({
      id: value.id,
      latitude: value.latitude,
      longitude: value.longitude,
    });
  };

  onMouseOutUserInfo = () => {
    this.setState({
      id: '',
      latitude: '',
      longitude: '',
    });
  };

  handleChangeTab = (tab) => {
    this.setState({
      tab,
    });
  };

  render() {
    const { classes, t, fixedEmergencyAlert } = this.props;
    const { position, data, latitude, longitude, tab } = this.state;
    let { mapData } = this.props.maps.toJS();
    let { userInformation, markerData } = this.props.patient.toJS();
    let { routerInMaps } = this.props.router.toJS();
    let { routerNoSignal } = this.props.dashboard.toJS();
    const { fixedEmergencyDevices } = this.props.device.toJS();
    // const { activeFullScreen } = this.props.screen.toJS();
    // let styleFullScreen = activeFullScreen ? { display: 'block' } : { display: 'none' };
    (mapData || []).forEach((data) => {
      // find router in map
      data.routerList = (routerInMaps || [])
        .filter((item) => item.mapId === data.id)
        .map((val, index) => {
          let data = {};
          data.id = val.id;
          data.name = val.name;
          data.serial = val.serial;
          data.mapId = val.mapId;
          data.place = val.place;
          data.referenceNumber = val.referenceNumber;
          data.localization = val.useForLocalization;
          data.routerTime =
            val.routerConnection && val.routerConnection.status === 'DISCONNECTED'
              ? val.routerConnection.createdDate
              : null;
          if (val.position) {
            let position = JSON.parse(val.position);
            data.x = position.x;
            data.y = position.y;
          } else {
            data.x = 0;
            data.y = 0;
          }
          return data;
        })
        .sort((a, b) => {
          return a.place.localeCompare(b.place, undefined, {
            numeric: true,
            sensitivity: 'base',
          });
        });
      // find device in map
      data.deviceList = (fixedEmergencyDevices || [])
        .filter((device) => device.mapId === data.id)
        .sort((a, b) => {
          return a.place.localeCompare(b.place, undefined, {
            numeric: true,
            sensitivity: 'base',
          });
        });
    });
    const sosDeviceSerials = [];
    (fixedEmergencyAlert || []).forEach((e) => {
      if (e.notifications.length > 0) {
        e.notifications.forEach((noti) => {
          sosDeviceSerials.push(noti.deviceSerial);
        });
      }
    });
    return (
      <React.Fragment>
        {!this.state.openPlan && localStorage.getItem('subgroup_type') === 'home' && (
          <div className={classes.geoMapPaper} style={{ width: '100vw', zIndex: 0 }}>
            <div className={classes.mapContainer}>
              <Map center={this.state.center} zoom={10}>
                <TileLayer
                  url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                />
                {markerData.map((element, index) => (
                  <Marker
                    key={index}
                    position={element.position}
                    onMouseOver={this.onMouseOver}
                    onMouseOut={this.onMouseOut}
                    onClick={this.handleClick}
                    icon={
                      element.position.lat === latitude && element.position.lng === longitude
                        ? redMarker
                        : defaultMarker
                    }
                  >
                    <Popup>
                      <Grid item xs={12} sm={12} md={12}>
                        {data.amountOfHome > 1 ? (
                          <Grid container style={{ marginTop: '-25px' }}>
                            <Home className={classes.iconStyle} />
                            <Typography
                              className={classes.popupHeader}
                              style={{
                                marginBottom: '-35px',
                                marginLeft: '-10px',
                              }}
                            >
                              {`x ${data.amountOfHome}`}
                            </Typography>
                            <AccountCircle
                              style={{
                                marginTop: '5px',
                                marginRight: 10,
                                color: '#858484',
                              }}
                            />
                            <Typography
                              className={classes.popupHeader}
                              style={{
                                marginBottom: '-20px',
                                marginLeft: '-10px',
                                marginTop: 2,
                              }}
                            >
                              {`x ${data.patients.length}`}
                            </Typography>
                          </Grid>
                        ) : (
                          <Typography
                            className={classes.popupHeader}
                            style={{
                              marginBottom: '-35px',
                              marginTop: '-15px',
                            }}
                          >
                            <IconButton edge='start' color='inherit' aria-label='AccountCircle'>
                              <AccountCircle />
                            </IconButton>
                            {data.patients.length === 1
                              ? `${data.patients[0].firstname} ${data.patients[0].lastname}`
                              : `x ${data.patients.length}`}
                          </Typography>
                        )}
                        <div className={classes.popupDetail}>
                          <Typography className={classes.infoDetail}>
                            {`
                            ${data.userAddress.address ? data.userAddress.address : ''}
                            ${data.userAddress.city ? data.userAddress.city : ''}
                            ${data.userAddress.state ? data.userAddress.state : ''}
                            ${data.userAddress.province ? data.userAddress.province : ''}
                            ${data.userAddress.zipcode ? data.userAddress.zipcode : ''}
                            `}
                          </Typography>
                          <Typography className={classes.infoDetail} style={{ marginTop: '-20px' }}>
                            {data.tel ? `${t('tel')} ${data.tel}` : ''}
                          </Typography>
                        </div>
                      </Grid>
                    </Popup>
                  </Marker>
                ))}
              </Map>
            </div>
            <div className={this.state.openSidebar ? classes.openSidebar : classes.closeSidebar}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '-10px',
                }}
              >
                <IconButton size='small' onClick={this.handleToggle.bind(this)}>
                  <KeyboardArrowRight fontSize='inherit' />
                </IconButton>
                <h1 className={classes.headerRouterInfo} style={{ marginTop: '15px' }}>
                  {t('information')}
                </h1>
              </div>
              <List style={{ height: '90%', overflow: 'auto' }}>
                {(userInformation || []).map((val, index) => (
                  <ListItem style={{ padding: '4px 8px' }} key={index}>
                    <Card
                      variant='outlined'
                      className={
                        val.homeUserAddress.latitude === position.lat && val.homeUserAddress.longitude === position.lng
                          ? classes.rootFocus
                          : classes.root
                      }
                      style={{
                        backgroundColor: val.homeUserAddress.id === this.state.id ? '#f0f8ff' : '#ffff',
                      }}
                      onMouseOver={this.onMouseOverUserInfo.bind(this, val.homeUserAddress)}
                      onMouseOut={this.onMouseOutUserInfo}
                    >
                      <CardContent style={{ padding: '0px 0px 4px 0px' }}>
                        <ExpansionPanel
                          style={{
                            boxShadow: 'none',
                            backgroundColor: val.homeUserAddress.id === this.state.id ? '#f0f8ff' : '#ffff',
                          }}
                        >
                          <ExpansionPanelSummary
                            expandIcon={<ExpandMore />}
                            classes={{
                              content: classes.expansionPanelSummaryContent,
                            }}
                          >
                            <Typography className={classes.infoSubHeader}>
                              {`${val.homeUserAddress.profileName}`}
                            </Typography>
                          </ExpansionPanelSummary>
                          <ExpansionPanelDetails
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              padding: '0px 24px 0px',
                            }}
                          >
                            {(val.patients || []).map((item, i) => (
                              <div
                                key={i}
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                }}
                              >
                                <AccountCircle />
                                <Typography style={{ fontSize: 15, marginLeft: 5 }}>
                                  {`${item && item.firstname ? item.firstname : ''} ${
                                    item && item.lastname ? item.lastname : ''
                                  }`}
                                </Typography>
                              </div>
                            ))}
                          </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <div style={{ marginLeft: 20 }}>
                          <Typography className={classes.infoDetail}>
                            {`
                              ${val.homeUserAddress.address ? val.homeUserAddress.address : ''}
                              ${val.homeUserAddress.city ? val.homeUserAddress.city : ''}
                              ${val.homeUserAddress.state ? val.homeUserAddress.state : ''}
                              ${val.homeUserAddress.province ? val.homeUserAddress.province : ''}
                              ${val.homeUserAddress.zipcode ? val.homeUserAddress.zipcode : ''}
                              `}
                          </Typography>
                          <Typography className={classes.infoDetail}>{`${t('tel')} ${
                            val.homeUserAddress.tel ? val.homeUserAddress.tel : '-'
                          }`}</Typography>
                        </div>
                      </CardContent>
                    </Card>
                  </ListItem>
                ))}
              </List>
            </div>
            <div className={classes.togglebtn} style={{ display: this.state.openSidebar ? 'none' : 'block' }}>
              <Button onClick={this.handleToggle.bind(this)} className={classes.btnInfo} variant='outlined'>
                {t('info')}
              </Button>
            </div>
          </div>
        )}

        {(this.state.openPlan || (localStorage.getItem('subgroup_type') === 'hospital' && mapData.length > 0)) && (
          <Grid container className={classes.paper}>
            {/* <Grid item xs={12} sm={12} md={12} className={classes.buttonClose}>
              {localStorage.getItem("subgroup_type") === "home" && (
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={this.handleClose}
                  aria-label="close"
                >
                  <Close />
                </IconButton>
              )}
            </Grid> */}

            <Grid container style={{ padding: '20px 102px 10px' }}>
              <Button
                id='router'
                variant='outlined'
                color='primary'
                onClick={() => this.handleChangeTab(0)}
                style={{
                  marginRight: 10,
                  borderRadius: 8,
                  backgroundColor: tab === 0 ? '#E5F9F6' : '#FFFFFF',
                }}
              >
                <svg width='20' height='20' viewBox='0 0 20 20'>
                  <use xlinkHref={`/images/map.svg#router`} />
                </svg>
                <div style={{ marginLeft: 5 }}>{t('router')}</div>
              </Button>
              <Button
                id='emergency_alarm'
                variant='outlined'
                color='primary'
                onClick={() => this.handleChangeTab(1)}
                style={{
                  borderRadius: 8,
                  backgroundColor: tab === 1 ? '#E5F9F6' : '#FFFFFF',
                }}
              >
                <svg width='20' height='20' viewBox='0 0 20 20'>
                  <use xlinkHref={`/images/map.svg#sos-device`} />
                </svg>
                <div style={{ marginLeft: 5 }}>{t('alert_emergency_alarm')}</div>
              </Button>
            </Grid>

            {(mapData || []).map((item) =>
              tab === 0 ? (
                <Grid container key={item.id} style={{ marginBottom: 20, justifyContent: 'space-around' }}>
                  <Grid item xs={12} sm={12} md={7} lg={7}>
                    <div
                      className={classes.boxImage}
                      style={{
                        background: `url(${item.imgUrl || ''}) center center no-repeat`,
                      }}
                    >
                      {(item.routerList || []).map((val) => {
                        const isPointer = this.state.routerIcon && this.state.routerSerial === val.serial;
                        const isNoSignal = routerNoSignal.some((data) => data.routerId === val.serial);

                        // Determine background color based on state
                        const backgroundColor = isPointer
                          ? isNoSignal
                            ? '#F8B7AD'
                            : '#8ECDC5'
                          : isNoSignal
                            ? '#EB5861'
                            : '#009D9A';

                        // Determine the icon to display
                        const IconComponent = val.localization ? LocationOn : Router;

                        return (
                          val.mapId === item.id && (
                            <div
                              key={val.id}
                              className={classes.router}
                              style={{
                                background: backgroundColor,
                                left: `${val.x - 1.5}%`,
                                top: `${val.y - 1.5}%`,
                              }}
                            >
                              <IconComponent
                                className={classes.iconActivity}
                                fontSize='default'
                                onMouseEnter={() =>
                                  this.setState({
                                    routerIcon: true,
                                    routerSerial: val.serial,
                                  })
                                }
                                onMouseLeave={() =>
                                  this.setState({
                                    routerIcon: false,
                                    routerSerial: '',
                                  })
                                }
                              />
                            </div>
                          )
                        );
                      })}

                      {/* {(item.routerList || []).map(
                        (val, index) => (
                          (this.isPointer = this.state.routerIcon === true && this.state.routerSerial === val.serial),
                          (this.isNoSignal = routerNoSignal.find((data) => data.routerId === val.serial)),
                          (
                            <div key={val.id}>
                              {val.mapId === item.id ? (
                                <div
                                  className={classes.router}
                                  style={{
                                    background: this.isPointer
                                      ? this.isNoSignal
                                        ? '#F8B7AD'
                                        : '#8ECDC5'
                                      : this.isNoSignal
                                        ? '#EB5861'
                                        : '#009D9A',
                                    left: `${val.x - 1.5}%`,
                                    top: `${val.y - 1.5}%`,
                                  }}
                                >
                                  {val.localization ? (
                                    <LocationOn
                                      className={classes.iconActivity}
                                      fontSize='default'
                                      onMouseEnter={() =>
                                        this.setState({
                                          routerIcon: true,
                                          routerSerial: val.serial,
                                        })
                                      }
                                      onMouseLeave={() =>
                                        this.setState({
                                          routerIcon: false,
                                          routerSerial: '',
                                        })
                                      }
                                    />
                                  ) : (
                                    <Router
                                      className={classes.iconActivity}
                                      fontSize='default'
                                      onMouseEnter={() =>
                                        this.setState({
                                          routerIcon: true,
                                          routerSerial: val.serial,
                                        })
                                      }
                                      onMouseLeave={() =>
                                        this.setState({
                                          routerIcon: false,
                                          routerSerial: '',
                                        })
                                      }
                                    />
                                  )}
                                </div>
                              ) : (
                                ''
                              )}
                            </div>
                          )
                        ),
                      )} */}
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <div className={classes.routerInfoBox}>
                      <h3 className={classes.headerRouterInfo}>{t('router_Information')}</h3>
                      {(item.routerList || []).map((val, index) => {
                        const isNoSignal = routerNoSignal.some((data) => data.routerId === val.serial);
                        const isCurrentRouter = this.state.routerSerial === val.serial;
                        const backgroundColor = isCurrentRouter
                          ? isNoSignal
                            ? '#F8B7AD'
                            : '#8ECDC5'
                          : isNoSignal
                            ? '#EB5861'
                            : '#009D9A';

                        const tooltipTitle = (
                          <div>
                            <div>
                              {t('place')}: {val.place || '-'}
                            </div>
                            <div>
                              {t('name')}: {val.name}
                            </div>
                            <div>
                              {t('router_reference_number')}: {val.referenceNumber || '-'}
                            </div>
                            <div>
                              {t('serial')}: {val.serial}
                            </div>
                            {isCurrentRouter && val.routerTime && (
                              <div>
                                {t('alert_last_seen')}: {getTimeFormatted(val.routerTime, t)}
                              </div>
                            )}
                          </div>
                        );

                        return (
                          val.mapId === item.id && (
                            <div key={index}>
                              <Tooltip
                                title={tooltipTitle}
                                placement='bottom-start'
                                classes={{ tooltip: classes.tooltipStyle }}
                                followcursor='true'
                              >
                                <p
                                  style={{
                                    color: backgroundColor,
                                    display: val.mapId === item.id ? '' : 'none',
                                  }}
                                  className={isCurrentRouter ? classes.textInfoHover : classes.textInfo}
                                  onMouseEnter={() =>
                                    this.setState({
                                      routerIcon: true,
                                      routerSerial: val.serial,
                                    })
                                  }
                                  onMouseLeave={() =>
                                    this.setState({
                                      routerIcon: false,
                                      routerSerial: '',
                                    })
                                  }
                                >
                                  {index + 1}. {val.place || val.name}
                                  {val.name && val.name !== '-' ? ` - ${val.name}` : ''}
                                </p>
                              </Tooltip>
                            </div>
                          )
                        );
                      })}

                      {/* {(item.routerList || []).map(
                        (val, index) => (
                          (this.isNoSignal = routerNoSignal.find((data) => data.routerId === val.serial)),
                          (
                            <div key={index}>
                              <Tooltip
                                title={
                                  <div>
                                    <div>
                                      {t('place')}: {val.place ? val.place : '-'}
                                    </div>
                                    <div>
                                      {t('name')}: {val.name}
                                    </div>
                                    <div>
                                      {t('router_reference_number')}: {val.referenceNumber ? val.referenceNumber : '-'}
                                    </div>
                                    <div>
                                      {t('serial')}: {val.serial}
                                    </div>
                                    {val.serial === this.state.routerSerial && val.routerTime && (
                                      <div>
                                        {t('alert_last_seen')}: {getTimeFormatted(val.routerTime, t)}
                                      </div>
                                    )}
                                  </div>
                                }
                                placement='bottom-start'
                                classes={{ tooltip: classes.tooltipStyle }}
                                followcursor='true'
                              >
                                <p
                                  key={index}
                                  style={{
                                    color:
                                      this.state.routerSerial === val.serial
                                        ? this.isNoSignal
                                          ? '#F8B7AD'
                                          : '#8ECDC5'
                                        : routerNoSignal.find((data) => data.routerId === val.serial)
                                          ? '#EB5861'
                                          : '#009D9A',
                                    display: val.mapId === item.id ? '' : 'none',
                                  }}
                                  className={
                                    val.serial === this.state.routerSerial ? classes.textInfoHover : classes.textInfo
                                  }
                                  onMouseEnter={() =>
                                    this.setState({
                                      routerIcon: true,
                                      routerSerial: val.serial,
                                    })
                                  }
                                  onMouseLeave={() =>
                                    this.setState({
                                      routerIcon: false,
                                      routerSerial: '',
                                    })
                                  }
                                >
                                  {index + 1}. {val.place ? val.place : val.name}
                                  {val.name && val.name !== '-' ? `-${val.name}` : ''}
                                </p>
                              </Tooltip>
                            </div>
                          )
                        ),
                      )} */}
                    </div>
                  </Grid>
                </Grid>
              ) : (
                <Grid container key={item.id} style={{ marginBottom: 20, justifyContent: 'space-around' }}>
                  <Grid item xs={12} sm={12} md={7} lg={7}>
                    <div
                      className={classes.boxImage}
                      style={{
                        background: `url(${item.imgUrl || ''}) center center no-repeat`,
                      }}
                    >
                      {(item.deviceList || []).map((val, index) => (
                        <div key={index}>
                          {val.mapId === item.id ? (
                            <div
                              onMouseEnter={() =>
                                this.setState({
                                  deviceSerial: val.serial,
                                })
                              }
                              onMouseLeave={() =>
                                this.setState({
                                  deviceSerial: '',
                                })
                              }
                              className={classes.sosDevice}
                              style={{
                                left: val.mapPosition ? `${val.mapPosition.x - 1.5}%` : 0,
                                top: val.mapPosition ? `${val.mapPosition.y - 1.5}%` : 0,
                              }}
                            >
                              <div
                                className={classes.sosButton}
                                style={{
                                  backgroundColor: sosDeviceSerials.includes(val.serial)
                                    ? this.state.deviceSerial === val.serial
                                      ? '#F4724D'
                                      : '#EB5861'
                                    : this.state.deviceSerial === val.serial
                                      ? '#F4724D'
                                      : '#10b0c3',
                                }}
                              >
                                <svg width='40' height='40' viewBox='0 0 84 75'>
                                  <use xlinkHref={`/images/map.svg#bell`} />
                                </svg>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      ))}
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <div className={classes.routerInfoBox}>
                      <h3 className={classes.headerRouterInfo}>{t('emergency_alarm_Information')}</h3>
                      {(item.deviceList || []).map((val, index) => (
                        <div key={index}>
                          <Tooltip
                            title={
                              <div>
                                {val.place ? val.place : val.name}
                                <div>
                                  {t('serial')}: {val.serial}
                                </div>
                                <div>
                                  {t('device_type')}: {val.deviceVersion ? val.deviceVersion.name : '-'}
                                </div>
                              </div>
                            }
                            placement='bottom-start'
                            classes={{ tooltip: classes.tooltipStyle }}
                            followcursor='true'
                          >
                            <p
                              key={index}
                              style={{
                                color: sosDeviceSerials.includes(val.serial)
                                  ? this.state.deviceSerial === val.serial
                                    ? '#F4724D'
                                    : '#EB5861'
                                  : this.state.deviceSerial === val.serial
                                    ? '#F4724D'
                                    : '#10b0c3',
                                display: val.mapId === item.id ? '' : 'none',
                              }}
                              className={
                                val.serial === this.state.routerSerial ? classes.textInfoHover : classes.textInfo
                              }
                              onMouseEnter={() =>
                                this.setState({
                                  deviceSerial: val.serial,
                                })
                              }
                              onMouseLeave={() =>
                                this.setState({
                                  deviceSerial: '',
                                })
                              }
                            >
                              {index + 1}. {val.place ? val.place : val.name}
                              {val.name && val.name !== '-' ? `-${val.name}` : ''}
                            </p>
                          </Tooltip>
                        </div>
                      ))}
                    </div>
                  </Grid>
                </Grid>
              ),
            )}
          </Grid>
        )}
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  paper: {
    position: 'relative',
    display: 'flex',
    marginTop: '20px',
    marginLeft: '22px',
    marginRight: '5px',
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    borderRadius: '4px',
    background: 'white',
  },
  boxImage: {
    position: 'relative',
    width: '650px',
    height: '650px',
    backgroundSize: 'contain !important',
    backgroundColor: 'gray',
    border: 'solid 1px',
    borderRadius: '2px',
    margin: '0 auto 0',
    marginTop: '20px',
    marginBottom: '20px',
    color: theme.palette.border.primary,
    [theme.breakpoints.only('md')]: {
      width: '605px',
      height: '605px',
    },
  },
  iconActivity: {
    color: '#000',
  },
  router: {
    textAlign: 'center',
    width: '30px',
    height: '30px',
    position: 'absolute',
    borderRadius: '50%',
    cursor: 'pointer',
    maxHeight: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sosDevice: {
    textAlign: 'center',
    position: 'absolute',
    borderRadius: '50%',
    cursor: 'pointer',
  },
  fakeToolbar: {
    minHeight: '65px',
    backgroundColor: 'white',
    width: '100%',
  },
  routerInfoBox: {
    padding: '10px',
    fontSize: '16px',
    border: 'solid 1px',
    borderRadius: '2px',
    margin: '20px',
    maxHeight: '650px',
    overflow: 'auto',
    color: theme.palette.border.primary,
  },
  headerRouterInfo: {
    color: theme.palette.text.header,
    fontSize: 20,
    marginBottom: 5,
    fontWeight: 500,
  },
  mapContainer: {
    position: 'relative',
    width: '100%',
    height: '650px',
    margin: '0 auto 0',
  },
  buttonClose: {
    textAlign: 'right',
    paddingTop: 10,
    paddingRight: 10,
  },
  root: {
    // marginBottom: '10px',
    // marginTop: '10px',
    // padding: '10px'
  },
  rootFocus: {
    borderStyle: 'solid',
    borderColor: '#009688',
    borderWidth: '2.0px',
  },
  infoSubHeader: {
    fontSize: '20px',
    color: '#858484',
    marginBottom: '-5px',
  },
  infoDetail: {
    color: '#C3C1C1',
    fontFamily: 'Kanit,sans-serif',
  },
  popupHeader: {
    fontSize: '20px',
    color: '#858484',
  },
  popupDetail: {
    marginLeft: '20px',
    marginTop: '35px',
  },
  openSidebar: {
    position: 'absolute',
    right: 0,
    top: 0,
    width: '300px',
    height: '100%',
    overflow: 'hidden',
    zIndex: 10001,
    backgroundColor: 'white',
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
  },
  closeSidebar: {
    position: 'absolute',
    right: '-300px',
    top: 0,
    width: 0,
  },
  togglebtn: {
    position: 'absolute',
    display: 'flex',
    right: 0,
    top: 0,
  },
  geoMapPaper: {
    position: 'relative',
    display: 'flex',
    marginTop: '20px',
    marginLeft: '22px',
    marginRight: '5px',
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    borderRadius: '4px',
    background: 'white',
    overflow: 'hidden',
  },
  btnInfo: {
    textAlign: 'center',
    color: '#009688',
    fontFamily: 'Kanit,sans-serif',
    fontSize: 20,
    borderColor: '#009688',
    zIndex: 1000000,
    backgroundColor: 'white',
  },
  expansionPanelSummaryContent: {
    margin: '8px 0',
  },
  iconStyle: {
    marginTop: '20px',
    marginRight: '10px',
    color: '#858484',
  },
  tooltipStyle: {
    fontSize: '16px',
  },
  sosButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    borderRadius: '50%',
    width: 28,
    height: 28,
    cursor: 'pointer',
    // "&:hover": {
    //   backgroundColor: theme.palette.secondary.dark,
    // },
  },
  textInfo: {
    fontSize: '16px',
    fontWeight: 500,
  },
  textInfoHover: {
    fontSize: '20px',
    fontWeight: 700,
  },
});

export const page = inject('maps', 'router', 'dashboard', 'screen', 'patient', 'device')(observer(Maps));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
